var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import withPaddingAndMargin from '../withPaddingAndMargin';

var Button = function Button(_ref) {
  var className = _ref.className,
      color = _ref.color,
      disabled = _ref.disabled,
      loading = _ref.loading,
      outline = _ref.outline,
      size = _ref.size,
      text = _ref.text,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ['className', 'color', 'disabled', 'loading', 'outline', 'size', 'text', 'type']);

  var buttonColor = (color ? 'dd-btn-' + color : 'dd-btn-default') + (outline ? '-outline' : '');
  var buttonSize = size ? 'dd-btn-' + size : 'dd-btn-md';
  return React.createElement('button', _extends({}, props, {
    type: type ? type : 'submit',
    disabled: !!disabled || !!loading,
    className: 'dd-btn ' + buttonColor + ' ' + buttonSize + ' ' + className
  }), React.createElement('div', {
    className: 'dd-btn-container'
  }, React.createElement('span', {
    className: 'dd-btn-text ' + (loading ? 'active' : '')
  }, text), loading && React.createElement('span', {
    className: 'dd-btn-loader-spinner'
  }, React.createElement(FontAwesomeIcon, {
    icon: 'spinner',
    spin: true
  }))));
};

export default withPaddingAndMargin(Button);